import React from 'react';

// A verse's reference label. When the recording has timings for the verse it is
// a button (with a ▶ to its left) that plays from there; otherwise it is the
// plain label it always was. It sits outside AnnotatedVerse, so it is never
// counted in highlight and note offsets.
export default function VerseRef({ text, onPlay, label }) {
  if (!onPlay) return <span className="verse-ref">{text}</span>;
  return (
    <button type="button" className="verse-ref verse-ref-play" onClick={onPlay} title={label} aria-label={label}>
      <span className="verse-play-icon" aria-hidden="true">▶</span>{text}
    </button>
  );
}
